import type { CalendarDesign } from "#internal"

import { CalendarMonthAreas } from "../CalendarMonthAreas"
import { PictureCover } from "../PictureCover"

/** Akura, a stitched square calendar: the year low on its picture; a picture facing each month, its name over its grid, the contact under. */
export const Akura: CalendarDesign = {
  cover: PictureCover({ at: 0.3, size: 0.16 }),
  page: (boxes, month) => CalendarMonthAreas(boxes, month, false),
  pages: "spread",
}
